export const iconFontAwesomeGamingDiceFive = (
	<i className="fa-solid fa-dice-five"></i>
);
